"use strict";

import $ from 'jquery';
import "@fontsource/montserrat/latin-600.css";
import "@fontsource/montserrat/latin-800.css";
import "@fontsource/open-sans/latin-300.css";
import "@fontsource/open-sans/latin-300-italic.css";
import "@fontsource/open-sans/latin-600.css";
import "@fontsource/open-sans/latin-600-italic.css";
import "@fontsource/open-sans/latin-700.css";

require("jquery-ui/ui/widgets/autocomplete");
require("jquery-ui/ui/widgets/resizable");
require("jquery-ui/ui/widgets/sortable");
require("jquery-ui/ui/widgets/droppable");
require("jquery-ui/ui/effect");
require("bootstrap");
import toastr from 'toastr';
import bootstrapMenu from 'bootstrap-menu';
import 'bootstrap-datepicker';
import bootstrapDialog from 'bootstrap4-dialog';
require('dropzone');
global.$ = global.jQuery = $;
global.toastr = toastr;
global.BootstrapMenu = bootstrapMenu;
global.BootstrapDialog = bootstrapDialog;
import '../node_modules/bootstrap-icons/font/bootstrap-icons.css';
import '../node_modules/bootstrap-tagsinput/dist/bootstrap-tagsinput.css';
// require('../node_modules/bootstrap-typeahead/bootstrap-typeahead.js');
// require('../node_modules/bootstrap-tagsinput/dist/bootstrap-tagsinput.js');
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.de.js');
require('magnific-popup');

import dayjs from "dayjs";
global.moment = dayjs;
require('dayjs/locale/de');
dayjs.locale('de');
import localeData from "dayjs/plugin/localeData";
import localizedFormat from "dayjs/plugin/localizedFormat";
import isoWeek from "dayjs/plugin/isoWeek";
import arraySupport from "dayjs/plugin/arraySupport";
import badMutable from "dayjs/plugin/badMutable";
import utc from "dayjs/plugin/utc";
import duration from "dayjs/plugin/duration";
import relativeTime from "dayjs/plugin/relativeTime";
import customParseFormat from "dayjs/plugin/customParseFormat";

// Load plugins
dayjs.extend(localeData);
dayjs.extend(localizedFormat);
dayjs.extend(isoWeek);
dayjs.extend(arraySupport);
dayjs.extend(badMutable);
dayjs.extend(utc);
dayjs.extend(duration);
dayjs.extend(customParseFormat);
dayjs.extend(relativeTime);
global.dayjs = dayjs;

console.log("dayjs", dayjs.localeData().longDateFormat('L'));

require('jquery-treetable');
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.de.js');

require('inputmask/dist/jquery.inputmask.js');
require('inputmask/lib/extensions/inputmask.date.extensions');
import inputmask from "inputmask";
global.inputmask = inputmask;

require('daterangepicker/daterangepicker.js');
require('./modules/bootstrap-dropselect/bootstrap-dropselect.js');
require('./modules/bootstrap-select-1.13.2/bootstrap-select.js');
require('./modules/ionrange/ion.rangeSlider.min.js');
require('./modules/scrolltofixed/scrolltofixed.js');
require('./modules/jquery-calx-master/js/numeral.min.js');
require('./modules/jquery-calx-master/jquery-calx-2.0.3.min.js');
require('./modules/jquery/jquery.timer.js');
require('./modules/ddslick/ddslick.js');
require('./modules/isloading/jquery.isloading.js');
require('./modules/ticker/ticker.js');

require('./js/autocompleter/autocompleter.js');
require('./js/pwa.js');
require('./js/forms.js');
require('./js/general.js');
require('./js/domhelper.js');
require('./js/class.messaging.js');
require('./js/class.dropzone.js');
require('./js/class.documents.js');
require('./js/class.contextmenu.js');
require('./js/class.notification.js');
require('./js/class.connection.js');
require('./js/class.slidein.js');
require('./js/class.navtabs.js');
require('./js/class.progress.js');
require('./js/class.help.js');
require('./js/fnc.numbers.js');
require('./js/class.portlet.js');
require('./js/class.upload.js');
require('./js/class.grid.js');
require('./js/class.exceltable.js');
require('./js/class.popup.js');
require('./js/class.taskQueue.js');
require('./js/template.js');
require('./js/project.js');
require('./js/project-ebkph.js');
require('./js/devis.js');
require('./js/devis-invitation.js');
require('./js/projectaddresses.js');
require('./js/communications.js');
require('./js/relations.js');
require('./js/mypositions.js');
require('./js/estimation.js');
require('./js/work.js');

require('./modules/table-dragndrop/table-dragndrop.js');
require('./modules/fancytree-master/src/jquery.fancytree.js');
require('./modules/fancytree-master/src/jquery.fancytree.menu.js');
require('./modules/jquery-calx-master/jquery-calx-2.0.3.js');

require('./modules/ckeditor-4.7/adapters/jquery.js');

import JsBase from "./jsbase/jsbase";

import ContextCalculationList from "./jsbase-components/context-calculation-list";
JsBase.register('context-calculation-list', ContextCalculationList);
import ContextCalculationTree from "./jsbase-components/context-calculation-tree";
JsBase.register('context-calculation-tree', ContextCalculationTree);
import ContextEstimationList from "./jsbase-components/context-estimation-list";
JsBase.register('context-estimation-list', ContextEstimationList);
import ContextEstimationDetailOptions from "./jsbase-components/context-estimation-detail-options";
JsBase.register('context-estimation-detail-options', ContextEstimationDetailOptions);
import ContextTemplatePosition from "./jsbase-components/context-template-position";
JsBase.register('context-template-position', ContextTemplatePosition);
import ContextTemplatePrice from "./jsbase-components/context-template-price";
JsBase.register('context-template-price', ContextTemplatePrice);
import ContextBaseEstimation from "./jsbase-components/context-base-estimation";
JsBase.register('context-base-estimation', ContextBaseEstimation);
import ContextBkdbTree from "./jsbase-components/context-bkdb-tree";
JsBase.register('context-bkdb-tree', ContextBkdbTree);
import ContextDevisPositions from "./jsbase-components/context-devis-positions";
JsBase.register('context-devis-positions', ContextDevisPositions);
import ContextDevisCatalogs from "./jsbase-components/context-devis-catalogs";
JsBase.register('context-devis-catalogs', ContextDevisCatalogs);
import ContextDevisList from "./jsbase-components/context-devis-list";
JsBase.register('context-devis-list', ContextDevisList);
import ContextDevisDocPositions from "./jsbase-components/context-devis-doc-positions";
JsBase.register('context-devis-doc-positions', ContextDevisDocPositions);
import ContextWorkList from "./jsbase-components/context-work-list";
JsBase.register('context-work-list', ContextWorkList);
import ListInlineSearch from "./jsbase-components/list-inline-search";
JsBase.register('list-inline-search', ListInlineSearch);
import ContextDevisEvaluationHeader from "./jsbase-components/context-evaluation-header";
JsBase.register('context-evaluation-header', ContextDevisEvaluationHeader);
import AjaxPaging from "./jsbase-components/ajax-paging";
JsBase.register('ajax-paging', AjaxPaging);
import LoadPartBtn from "./jsbase-components/load-part-btn";
JsBase.register('load-part-btn', LoadPartBtn);
import PermissionToggle from "./jsbase-components/permission-toggle";
JsBase.register('permission-toggle', PermissionToggle);
import FilteredList from "./jsbase-components/filtered-list";
JsBase.register('filtered-list', FilteredList);
import BkdbSlidein from "./jsbase-components/bkdb-slidein";
JsBase.register('bkdb-slidein', BkdbSlidein);
import BtnAddKeyNumber from "./jsbase-components/btn-add-key-number";
JsBase.register('btn-add-key-number', BtnAddKeyNumber);
import CssToggler from "./jsbase-components/css-toggler";
JsBase.register('css-toggler', CssToggler);
import DateRangePicker from "./jsbase-components/daterangepicker";
JsBase.register('daterangepicker', DateRangePicker);

$(document).on('content-ready', function(ev, data) {
    if (data[0]) {
        JsBase.initAll(data[0]);
    }
});

import '../node_modules/bootstrap-datepicker/dist/css/bootstrap-datepicker.css';
import '../node_modules/bootstrap4-dialog/dist/css/bootstrap-dialog.css';
import '../node_modules/daterangepicker/daterangepicker.css';
import '../node_modules/jquery-treetable/css/jquery.treetable.css';
import '../node_modules/magnific-popup/dist/magnific-popup.css';
import '../node_modules/toastr/toastr.scss';

import './modules/ionrange/ion.rangeSlider.css';
import './modules/ionrange/ion.rangeSlider.skinNice.css';
import './modules/dropzone-upload/dropzone.css';
import './modules/ddslick/ddslick.css';
import './modules/bootstrap-dropselect/bootstrap-dropselect.css';
import './modules/bootstrap-select-1.13.2/bootstrap-select.css';
import './modules/isloading/isloading.css';
//import './js/autocompleter/autocompleter.scss';
import './css/jquery.treetable.theme.scss';
import './css/architool/help.scss';
import './css/architool/bootstrap.scss';
import './css/architool/devis.scss';
import './css/architool/work.scss';
import './css/architool/menu-left.scss';
import './css/website.scss';
